export const TOGGLE_MOBILE_DRAWER_PROFILE = 'toggle-mobile-drawer-profile'
export const TOGGLE_MOBILE_DRAWER = 'toggle-mobile-drawer'
export const TOGGLE_MOBILE_MENU = 'toggle-navbar-mobile-menu'
export const TOGGLE_MARKETPLACE = 'toggle-navbar-marketplace'
